import { Accordion } from 'accordion';

export default function () {
  document.querySelectorAll('.collapse-list').forEach(list => {
    // eslint-disable-next-line no-new
    new Accordion(list, {
      modal: true,
    });
  });
}
